import { createFileRoute } from '@tanstack/react-router';

import { SchedulePage } from '@/features/teacher/SchedulePage';

export const Route = createFileRoute('/_authed/teacher/schedule')({
  validateSearch: (search): { lesson?: string } => ({
    lesson: typeof search.lesson === 'string' ? search.lesson : undefined,
  }),
  component: SchedulePage,
});
